exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-nova-stranka-js": () => import("./../../../src/pages/nova-stranka.js" /* webpackChunkName: "component---src-pages-nova-stranka-js" */)
}

